import { render, staticRenderFns } from "./MultiStepForm.vue?vue&type=template&id=10b0854c&scoped=true&"
import script from "./MultiStepForm.vue?vue&type=script&lang=js&"
export * from "./MultiStepForm.vue?vue&type=script&lang=js&"
import style0 from "./MultiStepForm.vue?vue&type=style&index=0&id=10b0854c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b0854c",
  null
  
)

export default component.exports